import React, { useEffect, useState } from "react";
import AppShell from "../../components/argus/AppShell";
import { Button } from "../../components/ui/button";
import { FileText, Download } from "lucide-react";
import { api, API } from "../../lib/api";
import { toast } from "sonner";

export default function Reports() {
  const [projects, setProjects] = useState([]);

  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data)); }, []);

  const download = async (p) => {
    try {
      const token = localStorage.getItem("argus.token");
      const r = await fetch(`${API}/reports/${p.id}`, { headers: { Authorization: `Bearer ${token}` } });
      if (!r.ok) throw new Error("Report failed");
      const b = await r.blob();
      const u = URL.createObjectURL(b);
      const a = document.createElement("a");
      a.href = u;
      a.download = `argus-${p.name.replace(/\s+/g, "-")}.pdf`;
      a.click();
      URL.revokeObjectURL(u);
      toast.success("Report downloaded.");
    } catch (e) {
      toast.error("Couldn't generate the report.");
    }
  };

  return (
    <AppShell title="Reports">
      <p className="text-ink/60 mb-6 max-w-xl">Generate a PDF report per project. Executive summary up top, full findings with evidence below. Built to hand to a CEO.</p>

      {projects.length === 0 ? (
        <div className="rounded-xl border border-dashed border-line p-12 text-center" data-testid="reports-empty">
          <FileText size={28} className="mx-auto text-ink/40 mb-3" />
          <p className="text-ink/70">No projects yet — nothing to report on.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="reports-grid">
          {projects.map((p) => (
            <div key={p.id} className="rounded-xl border border-line bg-panel p-5" data-testid={`report-card-${p.id}`}>
              <div className="text-xs uppercase tracking-wider text-gold font-semibold mb-2">{p.type}</div>
              <h3 className="font-display text-xl mb-1">{p.name}</h3>
              <div className="text-xs text-ink/50 mb-4">
                Risk {(p.risk_score || 0).toFixed(1)} ·
                {" "}{Object.values(p.open_findings_count || {}).reduce((a, b) => a + b, 0)} open findings
              </div>
              <Button onClick={() => download(p)} className="w-full h-11 bg-gold text-paper hover:bg-gold2 font-semibold" data-testid={`report-download-${p.id}`}>
                <Download size={16} className="mr-2" /> Download My Report
              </Button>
            </div>
          ))}
        </div>
      )}
    </AppShell>
  );
}
